import React from "react";
import Banner from "../components/home/Banner";
import Products from "../components/home/Products";

import Middlesection from "../components/home/Middlesection";

const Home = () => {
  return (
    <div>
      <Banner />
      <Middlesection />
      <div className="w-full bg-gray-100 -mt-16 lgl:-mt-24 xl:-mt-36 py-10">
        <Products />
      </div>
    </div>
  );
};

export default Home;
